import { z } from 'zod'
import { ApiLocale } from '@library/enums'
import type { SystemParameterKey } from '@library/enums'
import {
  systemParameterItemSchema,
  type SystemParameterItem
} from './system-parameter-item'

export const systemParameterSchema = z.object({
  lang: z.nativeEnum(ApiLocale),
  type: z.string(),
  paramList: systemParameterItemSchema.array()
})

export interface SystemParameter<T extends SystemParameterKey>
  extends z.infer<typeof systemParameterSchema> {
  paramList: SystemParameterItem<T>[]
}
